module.exports = __webpack_public_path__ + "static/media/heavyScooter.daa9470e.svg";